import { dehydrate, QueryClient } from "react-query";

export const reactQueryConfig = {
  defaultOptions: {
    queries: {
      retryOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
};

export const dehydrateData = (queryClient: QueryClient) => {
  const _dehydrate = dehydrate(queryClient);
  return {
    dehydratedState: _dehydrate
  }
}
